const getters = {
    prelandings: (state) => state.prelandings
}

export default getters
